import createNotificationModel from './lib/create_notification_model';

import IdGenerator from 'scripts/domain/contracts/id_generator';
import NotificationType from './notification_type';

export default createNotificationModel(NotificationType.SUCCESS.toString(), {
  modelName: 'SuccessNotification',
  statics: {
    create(attrs) {
      return new this({
        id: IdGenerator.newId(),
        message: attrs.message,
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/success_notification.js